import type { TExposedFacilityDTO } from '@doutorsim/shared/exposed/facilities'
import { createContext, useContext } from 'react'

const FacilityContext = createContext<TExposedFacilityDTO | null>(null)

export const FacilityProvider = FacilityContext.Provider

export function useFacilityContext(): TExposedFacilityDTO | null {
  return useContext(FacilityContext)
}
